import { getProjects, disableProject } from '../webAPI/MKSService';

export function getProjectsRequest() {
	return function(dispatch) {
		dispatch({
			type: 'GET_PROJECTS_REQUEST'
		});

		return getProjects().then(
			// Faillure callback
			error => {
				dispatch({
					type: 'GET_PROJECTS_FAILLURE',
					error
				});
			},
			// Success callback
			result => {
				dispatch({
					type: 'GET_PROJECTS_SUCCESS',
					result
				});
			}
		);
	};
}

export function doDeleteProjectRequest(projectId) {
	return function(dispatch) {
		dispatch({
			type: 'DELETE_PROJECT_REQUEST',
			projectId
		});

		return disableProject(projectId).then(
			// Faillure callback
			error => {
				dispatch({
					type: 'DELETE_PROJECT_FAILLURE',
					error
				});
			},
			// Success callback
			result => {
				dispatch({
					type: 'DELETE_PROJECT_SUCCESS',
					result
				});
			}
		);
	};
}



// WEBPACK FOOTER //
// ./src/js/project-v2/projectsActions.js